import styled from 'styled-components';

export const StyledIconSlot = styled.span`
    display: flex;
    flex-shrink: 0;
    ${({ $disabled }) => $disabled && 'filter: grayscale(1); opacity: 0.4;'}

    svg {
        width: 48px;
        height: 48px;
    }
`;
